import { ROUTES } from 'configs/routes';

export const isPathMatch = (pathname: string, path: string) => pathname === path || pathname.startsWith(`${path}/`);

export const NON_MENU_TITLES: { path: string; title: string }[] = [
  { path: ROUTES.lk.favorites.path, title: 'Избранное' },
];
